export default function Footer() {
    return (
        <footer className="d-flex justify-content-center p-4">
            <p style={{fontSize:"20px"}}>Made with ❤️ by <a href="https://github.com/pixelhypercube">@pixelhypercube</a> using <a href="https://react.dev/">React.js</a></p>
        </footer>
    )
}